import { render } from "./Login_08_05.vue?vue&type=template&id=e4e043da&scoped=true"
import script from "./Login_08_05.vue?vue&type=script&lang=js"
export * from "./Login_08_05.vue?vue&type=script&lang=js"

import "./Login_08_05.vue?vue&type=style&index=0&id=e4e043da&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e043da"]])

export default __exports__